import { useState, useEffect } from 'react';
import { fetchActions } from '@/utils/loader';
import { ActionType, Action } from '@/lib/types';

const useFetchActions = (
  workspaceId: string,
  actionType: ActionType,
  startDate: string,
  endDate: string,
) => {
  const [actions, setActions] = useState<Action[]>([]);

  useEffect(() => {
    const loadActions = async () => {
      if (!workspaceId) return;
      const fetchedActions = await fetchActions(workspaceId, actionType, startDate, endDate);
      setActions(fetchedActions);
    };

    loadActions();
  }, [workspaceId, actionType, startDate, endDate]);

  return actions;
};

export default useFetchActions;
